<template>
	<view class="box">
		<view class="box_info">
			<image src="@/static/uni.png" mode="widthFix"></image>
			<view class="box_info_right">
				<view class="box_info_right_item">
					<text class="grey">物流公司：</text>
					<text class="grey">丹鸟KD</text>
				</view>
				<view class="box_info_right_item">
					<text class="grey">物流状态：</text>
					<text class="black">运输中</text>
				</view>
				<view class="box_info_right_item">
					<text class="grey">订单编号：</text>
					<text class="grey">380808403579340</text>
					<text class="margin">|</text>
					<text class="black">复制</text>
				</view>
			</view>
		</view>
		<view class="box_list">
			<view class="box_pay_desc_list">
				<view class="box_pay_desc_list_l">
					<view class="box_pay_desc_list_l_item">
						<view class="dian">
							<view class="dian_dian"></view>
						</view>
						<div class="xian_x"></div>
					</view>
					<view class="box_pay_desc_list_l_item">
						<view class="dian">
							<view class="dian_dian"></view>
						</view>
						<div class="xian_x"></div>
					</view>
					<view class="box_pay_desc_list_l_item">
						<view class="desad"></view>
						<div class="xian_x disable"></div>
					</view>
				</view>
				<view class="box_pay_desc_list_r">
					<view class="box_pay_desc_list_item">
						<view class="dian">
							<view class="dian_dian"></view>
						</view>
						<text class="qi">到达【上海市青浦区青浦新城揽投部】下一站【青浦新城】</text>
						<text class="time">2022-12-21 12:18</text>
					</view>
					<view class="box_pay_desc_list_item">
						<text class="qi">到达【上海市青浦区青浦新城揽投部】下一站【青浦新城】</text>
						<text class="time">2022-12-21 12:18</text>
					</view>
					<view class="box_pay_desc_list_item">
						<text class="qi">到达【上海市青浦区青浦新城揽投部】下一站【青浦新城】</text>
						<text class="time">2022-12-21 12:18</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_info {
			width: 100%;
			padding: 28rpx 32rpx;
			background-color: #ffffff;
			display: flex;
			align-items: flex-start;
			image {
				flex-shrink: 0;
				width: 144rpx;
				height: 144rpx;
				border-radius: 10rpx;
				margin-right: 16rpx;
			}
			.box_info_right {
				flex: 1;
				display: flex;
				flex-direction: column;
				.box_info_right_item {
					display: flex;
					align-items: flex-start;
					margin-top: 16rpx;
					&:first-child {
						margin: 0 !important;
					}
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
					}
					.margin {
						margin: 0 8rpx;
					}
					.grey {
						color: #999999 !important;
					}
					.black {
						color: #333333;
					}
				}
			}
		}
		.box_list {
			width: 100%;
			padding: 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 16rpx;
			.box_pay_desc_list {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				.box_pay_desc_list_l {
					width: 40rpx;
					margin-right: 20rpx;
					flex-shrink: 0;
					display: flex;
					flex-direction: column;
					.box_pay_desc_list_l_item {
						width: 100%;
						height: 128rpx;
						margin-top: 11rpx;
						position: relative;
						.disable {
							background-color: #D9D9D9 !important;
						}
						.xian_x {
							width: 2rpx;
							height: 135rpx;
							background-color: #D20A0A;
							position: absolute;
							top: 5rpx;
							left: 9rpx;
							z-index: 1;
						}
						.desad {
							width: 12rpx;
							height: 12rpx;
							border-radius: 50%;
							background-color: #D9D9D9;
							position: relative;
							z-index: 6;
							margin-left: 2rpx;
						}
						.dian {
							position: relative;
							z-index: 6;
							width: 20rpx;
							height: 20rpx;
							background: rgba(210,10,10,0.4);
							border-radius: 50%;
							display: flex;
							align-items: center;
							justify-content: center;
							.dian_dian {
								width: 12rpx;
								height: 12rpx;
								background: #D20A0A;
								border-radius: 50%;
							}
						}
					}
				}
				.box_pay_desc_list_r {
					flex: 1;
					display: flex;
					align-items: center;
					flex-direction: column;
					.box_pay_desc_list_item {
						width: 100%;
						display: flex;
						flex-direction: column;
						&:first-child {
							.qi {
								margin-top: 0 !important;
							}
						}
						.qi {
							font-size: 28rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
							margin-bottom: 12rpx;
							margin-top: 40rpx;
						}
						.time {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
					}
				}
			}
		}
	}
</style>